/**
 * `/lists/:slug` — one collection.
 *
 * The param is the **slug**, which is what `GET /api/v1/collections/{slug}`
 * takes and what every card on `/lists` links to. Mutations address the
 * collection by its ULID, read off the payload — the two identity spaces never
 * have to be resolved against each other.
 *
 * No `loader`, no data read here: the page component owns its reads, so there
 * is one cache and one invalidation story.
 */
import type { RouteObject } from 'react-router-dom';

export const collectionRoute: RouteObject = {
  path: 'lists/:slug',
  lazy: async () => {
    const { CollectionPage } = await import('./CollectionPage');
    return { Component: CollectionPage };
  },
};
